import { FC } from 'react';
import { INavbarItem } from '../types';

interface DropdownMenuProps {
    item: INavbarItem;
    activeDropdown: string | null;
}

export const DropdownMenu: FC<DropdownMenuProps> = ({ item, activeDropdown }) => {
  return (
    <>
    {activeDropdown === item.label && (
      <div className={`${"lg:absolute "}left-0 top-full bg-red-500 text-sedondary text-md text-nowrap space-y-2 lg:rounded shadow-lg min-w-60`}>
        <ul className='w-full'>
          {item.children?.map((child) => (
            <li key={child.label} className="w-full font-medium hover:bg-primary-dark hover:text-white lg:rounded-md">
              <a
                href={child.path}
                className="block px-4 py-2"
              >
                {child.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )}
    </>
  )
};